interface Props {
  className?: string;
}

const base = "h-4 w-4";

export const IconSparkle = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
    <path
      d="M12 3l1.8 4.9L19 9.7l-5.2 1.8L12 16.4l-1.8-4.9L5 9.7l5.2-1.8L12 3Z"
      fill="currentColor"
    />
    <path d="M18.5 14.5l.9 2.4 2.6.9-2.6.9-.9 2.4-.9-2.4-2.6-.9 2.6-.9.9-2.4Z" fill="currentColor" opacity=".6" />
  </svg>
);

export const IconStar = ({ className = base, filled = false }: Props & { filled?: boolean }) => (
  <svg viewBox="0 0 24 24" className={className} fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.7" aria-hidden>
    <path d="M12 4.2l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 9.9l5.4-.8L12 4.2Z" strokeLinejoin="round" />
  </svg>
);

export const IconDownload = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 4v10m0 0l-3.5-3.5M12 14l3.5-3.5M5 17.5v1A1.5 1.5 0 006.5 20h11a1.5 1.5 0 001.5-1.5v-1" />
  </svg>
);

export const IconExpand = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M9 4H4v5M15 20h5v-5M20 9V4h-5M4 15v5h5" />
  </svg>
);

export const IconClose = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const IconHistory = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3.5 12a8.5 8.5 0 108.5-8.5A8.4 8.4 0 006 6.4M3.5 3.6v3.2h3.2M12 7.5V12l3 1.8" />
  </svg>
);

export const IconCopy = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" aria-hidden>
    <rect x="9" y="9" width="11" height="11" rx="2.2" />
    <path d="M15 6.5A2.5 2.5 0 0012.5 4h-6A2.5 2.5 0 004 6.5v6A2.5 2.5 0 006.5 15" strokeLinecap="round" />
  </svg>
);

export const IconTrash = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M4.5 6.5h15M9.5 6.5V5a1.5 1.5 0 011.5-1.5h2A1.5 1.5 0 0114.5 5v1.5M6.5 6.5l.8 12A1.7 1.7 0 009 20h6a1.7 1.7 0 001.7-1.5l.8-12M10.5 10v6M13.5 10v6" />
  </svg>
);

export const IconPlus = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IconMinus = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
    <path d="M5 12h14" />
  </svg>
);

export const IconCheck = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);

export const IconImage = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" aria-hidden>
    <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
    <circle cx="9" cy="10" r="1.6" />
    <path d="M4 17l4.5-5 3.5 4 3-3.2L20 17" strokeLinecap="round" />
  </svg>
);

export const IconRefresh = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M20 12a8 8 0 11-2.3-5.6M20 4v4h-4" />
  </svg>
);

export const IconStop = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
    <rect x="6.5" y="6.5" width="11" height="11" rx="2.5" />
  </svg>
);

export const IconZip = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" aria-hidden>
    <path d="M4 7.5A2.5 2.5 0 016.5 5h3l2 2.2h6A2.5 2.5 0 0120 9.7v7.8a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 014 17.5v-10Z" />
    <path d="M12.5 9.5h2M12.5 12h2M12.5 14.5h2" strokeLinecap="round" />
  </svg>
);

export const IconArrow = ({ className = base, dir = "right" }: Props & { dir?: "left" | "right" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden style={dir === "left" ? { transform: "scaleX(-1)" } : undefined}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);

export const IconTag = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M4 5.5A1.5 1.5 0 015.5 4h5.4a2 2 0 011.4.6l7.1 7.1a2 2 0 010 2.8l-4.9 4.9a2 2 0 01-2.8 0l-7.1-7.1a2 2 0 01-.6-1.4V5.5Z" />
    <circle cx="9" cy="9" r="1.3" fill="currentColor" stroke="none" />
  </svg>
);

export const IconFilter = ({ className = base }: Props) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M4 6h16M7 12h10M10 18h4" />
  </svg>
);
